import request from '../../shared/request';

export function getLectureDetails(classId, options) {
  if (!/^\d+$/.test(classId)) return;
  const query = options?.includeQuestions === false ? '?include_questions=false' : '';
  return request(`/v2/students/classes/${classId}${query}`, {
    method: 'GET',
  });
}

export function getLectureBlockQuestions(classId, blockId) {
  if (!/^\d+$/.test(classId) || !/^\d+$/.test(String(blockId))) return;
  return request(`/v2/students/classes/${classId}/blocks/${blockId}`, {
    method: 'GET',
  });
}

export function persistOngoingLectureObjective(ongoingPayload) {
  return request(`/v2/students/tests/ongoing/objective-questions`, {
    method: 'POST',
    body: JSON.stringify(ongoingPayload),
  });
}

export function persistOngoingLectureDecisionTree(ongoingPayload) {
  return request(`/v2/students/tests/ongoing/decision-tree`, {
    method: 'POST',
    body: JSON.stringify(ongoingPayload),
  });
}

export function persistOngoingLectureQuestionContext(ongoingPayload) {
  return request(`/v2/students/tests/ongoing/question-context`, {
    method: 'POST',
    body: JSON.stringify(ongoingPayload),
  });
}

export function persistOngoingLectureCaseStudy(ongoingPayload) {
  return request(`/v2/students/tests/ongoing/case-study`, {
    method: 'POST',
    body: JSON.stringify(ongoingPayload),
  });
}

export function persistOngoingLecture(userId, classId, ongoingPayload) {
  return request(`/v1/services/student/${userId}/lecture/${classId}/tests/ongoing/store`, {
    method: 'POST',
    body: JSON.stringify(ongoingPayload),
  });
}

export function getOngoingLecture(userId, classId, courseTag) {
  return request(`/v1/services/student/${userId}/lecture/${classId}/${courseTag}/tests/ongoing`, {
    method: 'GET',
  });
}

export function finishLecture(finalPayload) {
  return request(`/v2/students/exams`, {
    method: 'POST',
    body: JSON.stringify(finalPayload),
  });
}

export function registerPdfDownload(userId, courseTag, classId, idCourseClass) {
  return request(
    `/v1/services/aluno/pdf_downloaded?id_aluno=${userId}&tag_curso=${courseTag}&id_aula=${classId}&id_turma=${idCourseClass}`,
    {
      method: 'GET',
    }
  );
}

export function registerVideoPlay(userId, courseTag, classId, videoId, idCourseClass) {
  return request(
    `/v1/services/aluno/play_video?id_aluno=${userId}&tag_curso=${courseTag}&id_aula=${classId}&id_video=${videoId}&id_turma=${idCourseClass}`,
    {
      method: 'GET',
    }
  );
}

export function getFinishedLectures(classId) {
  const courseId = window.location.href.split('/')[4];
  return request(`/v1/services/student/tests/${classId}/course/${courseId}`, {
    method: 'GET',
  });
}

export const getFinishedLecturesToReview = (classId, courseId) => {
  return request(`/v2/students/exams/${classId}/${courseId}/finished`, {
    method: 'GET',
  });
}

export function getLectureWrongQuestions(lectureId) {
  return request(`/v2/students/exams/${lectureId}/review`, {
    method: 'GET',
  });
}

export function getClassesById(classId) {
  return request(`/v1/services/aulas/${classId}/response`, {
    method: 'GET',
  });
}

export const fetchGeneralText = async (filters) => {
  const courseCategoryParam = filters.courseCategoryId
    ? `&filtro[id_course_category]=${filters.courseCategoryId}`
    : '';
  return request(
    `/v1/report/scoreperformancetext?get=all&filtro[id_type_report]=${filters.typeReportId}${courseCategoryParam}&filtro[id_category_report]=${filters.categoryReportId}`
  );
};
